export default __webpack_public_path__ + "static/media/microsoft.0b8d4099.svg";